import React, { Fragment, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router";
import Select from "react-select";
import { toast } from "react-toastify";
import {
  deleteQuestion,
  getAllQuestions,
  getClassifications,
  getQuestionExport,
} from "../../../api/question.service";
import { getAuthours } from "../../../api/passage.service";
import {
  AddIcon,
  ApproveIcon,
  CaretDownSolidIcon,
  CaretUpSolidIcon,
  CopyIcon,
  CSVIcon,
  DeleteIcon,
  DiagnosticIcon,
  Disapprove,
  FilterIcon,
  HumanIcon,
  MachineIcon,
  PreviewIcon,
  ResetIcon,
  SpanishTransIcon,
  TextIcon,
  VideoLegendIcon,
} from "../../../assets/icons/index";
import { IQuestion, IQuestionSearch } from "../../../model/interface/question";
import { IStandard } from "../../../model/interface/standard";
import { TagColor } from "../../../model/tagColor";
import constant from "../../../utils/constant";
import DeleteModal from "../../shared/common/deleteModal";
import Tooltip from "../../shared/common/ellipsisText";
import ExportToCSV from "../../shared/common/exportToCsv";
import SelectPageSize from "../../shared/common/pageSizeDropdown";
import Pagination from "../../shared/common/pagination";
import TagSelector, { TagSelectorMode } from "../../shared/common/tagSelector";
import UgaItemIcon from "../../shared/common/ugaItemIcon";
import Loader from "../../shared/loader/loader";
import DropDownComponent from "./metadataDropDownList";
import PreviewModal from "./previewModal";
import QuestionTypeSelect from "./questionTypeSelect";
import AllowedTo from "../../shared/common/rbac";
import Permissions from "../../../utils/permissions";
import AccessDenied from "../../shared/common/accessDenied";
import MultiStateButton from "../../shared/common/multiStateButton";
import Copy from "../../shared/common/copy";
import { ISelectElement } from "../../../model/interface/keyValuePair";
import DatePicker from "react-datepicker";
import { getEndDate, getStartDate } from "../../../utils/dateHelper";
import { EXTERNAL_SOURCE_TYPES } from "./constants";

const publishedMultiState = [
  { label: "Published", value: true },
  { label: "Both", value: null, selected: true },
  { label: "Unpublished", value: false },
];

const activeMultiState = [
  { label: "Active", value: true },
  { label: "Both", value: null, selected: true },
  { label: "Inactive", value: false },
];

const translationMultiState = [
  { label: "All", value: 0, selected: true },
  { label: "Human", value: 1 },
  { label: "Machine", value: 2 },
];

const explanationMultiState = [
  { label: "All", value: 0, selected: true },
  { label: "Video", value: 1 },
  { label: "None", value: 4 },
];

const tagTypes = [
  {
    label: "Question",
    value: 2,
  },
  {
    label: "USATP - Question",
    value: 1,
  },
  {
    label: "USATP - Drag Drop",
    value: 3,
  },
  {
    label: "USATP - Video",
    value: 4,
  },
  {
    label: "USATP - EBSR",
    value: 5,
  },
];

const gradeLevelData = [
  {
    value: "ece",
    name: "Early Childhood Learning",
    label: "Early Childhood Learning (ece)",
  },
  { value: "elem", name: "Elementary", label: "Elementary (elem)" },
  { value: "ms", name: "Middle School", label: "Middle School (ms)" },
  { value: "hs", name: "High School", label: "High School (hs)" },
];

const defaultClassification = {
  label: "All",
  value: "0",
};
const defaultObject: ISelectElement = { label: "", value: "0" };
const defaultPageSize = 100;
function QuestionList(props: any) {
  const [categories, setCategories] = useState<ISelectElement[]>([]);
  const [selectedTagCategory, setSelectedTagCategory] =
    useState<ISelectElement>();
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [resetDropdownFlag, setResetDropdownFlag] = useState<boolean>(false);
  const [questionDelete, setQuestionDelete] = useState<number>(0);
  const [showDeletePopup, setShowDeletePopup] = useState<boolean>(false);
  const [questionList, setQuestionList] = useState<IQuestion[]>([]);
  const [sortAscending, setSortAscending] = useState<boolean>(true);
  const [orderByColumn, setOrderByColumn] = useState<string>("questionId");
  const [loading, setLoading] = useState<boolean>(false);
  const [subjects, setSubjects] = useState([]);
  const [state, setState] = useState([]);
  const [domain, setDomain] = useState([]);
  const [standard, setStandard] = useState([]);
  const [questionTypeIds, setQuestionTypeIds] = useState<number[]>([]);
  const [stateId, setStateId] = useState(0);
  const [gradeLevel, setGradeLevel] = useState({ label: "", value: "" });
  const [subjectId, setSubjectId] = useState<number>(0);
  const [domainId, setDomainId] = useState<number>(0);
  const [standardId, setStandardId] = useState<number>(0);
  const [questionId, setQuestionId] = useState<number>(0);
  const [dok, setDok] = useState<number>(0);
  const [tagId, setTagId] = useState<number>(0);
  const [isActive, setIsActive] = useState<boolean | undefined>(undefined);
  const [isPublished, setIsPublished] = useState<boolean | undefined>(
    undefined
  );
  const [translation, setTranslation] = useState<number>(0);
  const [explanation, setExplanation] = useState<number>(0);
  const [isDiagnostics, setIsDiagnostics] = useState<boolean>(false);
  const navigate = useNavigate();
  const [enableDisableStates, setEnableDisableStates] = useState<boolean>(true);
  const [enableDisableSubjects, setEnableDisableSubjects] =
    useState<boolean>(false);
  const [enableDisableDomains, setEnableDisableDomains] =
    useState<boolean>(true);
  const [enableDisableStandards, setEnableDisableStandards] =
    useState<boolean>(true);
  const [filterQuestionId, setFilterQuestionId] = useState<number>();
  const [filterQuestionText, setFilterQuestionText] = useState<string>();
  const [filterJsonDefinition, setFilterJsonDefinition] = useState<string>();
  const [filterSourceId, setFilterSourceId] = useState<string>();
  const [open, setOpen] = useState<boolean>(false);
  const [previewId, setPreviewId] = useState<string>("");
  const [questionToPreview, setQuestionToPreview] = useState<
    IQuestion | undefined
  >();
  const paginationRef: any = useRef(undefined);
  const pageSizeRef: any = useRef(undefined);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [questionIdPreview, setQuestionIdPreview] = useState<number>();
  const [questionIndexPreview, setQuestionIndexPreview] = useState<number>();
  const childRef: any = useRef(undefined);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [isFilter, setIsFilter] = useState<boolean>(false);
  const [externalSourceTypeId, setExternalSourceTypeId] = useState<number>(0);
  const [classification, setClassification] = useState<number | undefined>(0);
  const defaultValue = { label: null, value: "0" };
  const [selectedClassification, setSelectedClassification] = useState(
    defaultClassification
  );
  const [questionClassification, setQuestionClassification] = useState([]);
  const [selectedTagIds, setSelectedTagIds] = useState<Array<number>>([]);
  const [isReset, setIsResetFlag] = useState<boolean>(false);
  const [showLinkedItems, setShowLinkedItems] = useState<boolean>(true);
  const [contentArea, setContentArea] = useState([]);
  const [selectedContentArea, setSelectedContentArea] = useState(defaultValue);
  const [authors, setAuthors] = useState<ISelectElement[]>([]);
  const [selectedAuthor, setSelectedAuthor] =
    useState<ISelectElement>(defaultObject);
  const [feedbackSearchText, setFeedbackSearchText] = useState<string>();
  const [dateCreatedMin, setDateCreatedMin] = useState<Date>();
  const [dateCreatedMax, setDateCreatedMax] = useState<Date>();
  const [isInvalidDateRange, setIsInvalidDateRange] = useState<boolean>(false);

  const handleExternalSourceTypeIdChange = (e) => {
    if (e) {
      setExternalSourceTypeId(e.value);
      setFilterSourceId("");
    } else {
      setExternalSourceTypeId(0);
    }
  };
  async function bindCategories() {
    const service = await import("../../../api/category.service");
    service.getCategorys().then((response) => {
      const categoryTypes = response.data.data
        .map((_g) => {
          return {
            label: _g.name,
            value: parseInt(_g.categoryId),
          };
        })
        .filter((item) => item.value != 2);
      const selectedTagCat = categoryTypes.filter((i) => i.value === 1)[0];
      setSelectedTagCategory(selectedTagCat);
      setCategories(categoryTypes);
    });
  }

  const handleQuestionClassificationChange = (e) => {
    if (e) {
      setClassification(e.value);
      setSelectedClassification(e);
    } else {
      setClassification(0);
      setSelectedClassification(defaultClassification);
    }
  };
  const handleTagCategoryChange = (e) => {
    setSelectedTagCategory(e);
  };
  function handleSort(columnName) {
    setOrderByColumn(columnName);
    setSortAscending(!sortAscending);
  }

  useEffect(() => {
    if (isLoaded && questionList.length) {
      bindQuestionList();
    }
  }, [sortAscending]);

  function resetFilterHandler() {
    setResetDropdownFlag(!resetDropdownFlag);
    setQuestionId(0);
    setQuestionTypeIds([]);
    setStateId(0);
    setGradeLevel({ label: "", value: "" });
    setDomainId(0);
    setStandardId(0);
    setDok(0);
    setTagId(0);
    setIsActive(undefined);
    setIsPublished(undefined);
    setTranslation(0);
    setExplanation(0);
    setIsDiagnostics(false);
    setOrderByColumn("questionId");
    setSortAscending(true);
    setQuestionList([]);
    setIsResetFlag(true);
    setShowLinkedItems(true);
    paginationRef?.current?.onReset();
    pageSizeRef?.current?.onReset();
    setTimeout(() => {
      setResetDropdownFlag(false);
    }, 1500);
    setFilterQuestionId(0);
    setFilterQuestionText("");
    setFilterSourceId("");
    setExternalSourceTypeId(0);
    setClassification(undefined);
    setSelectedClassification(defaultClassification);
    setSelectedTagIds([]);
    setFeedbackSearchText("");
    setDateCreatedMax(undefined);
    setDateCreatedMin(undefined);
    setIsInvalidDateRange(false);
  }

  const bindQuestionListWithPageCheck = (
    filter: IQuestionSearch,
    onFilter?
  ) => {
    if (onFilter) setIsFilter(true);
    setLoading(true);
    getAllQuestions(filter).then((response: any) => {
      setLoading(false);
      const pageCount = Math.ceil(response.data.totalRecords / pageSize);
      if (pageNumber > pageCount && pageNumber > 1) {
        setQuestionList(response.data.data);
        setTotalPages(pageCount);
        setTotalRecords(response.data.totalRecords);
        setPageNumber(1);
      } else {
        setQuestionList(response.data.data);
        setTotalPages(pageCount);
        setTotalRecords(response.data.totalRecords);
      }

      if (onFilter) {
        paginationRef?.current?.onReset();
        pageSizeRef?.current?.onReset();
        setIsFilter(false);
      }
    });
  };

  function validateDates() {
    const dateRandeIsEmpty = isEmptyDateRange();
    setIsInvalidDateRange(dateRandeIsEmpty);
    if (dateRandeIsEmpty) {
      const missingValue =
        dateCreatedMax == null ? "created date end" : "created date start";
      toast.error(
        `You must select a valid date range, ${missingValue} is missing.`
      );
    }
    return !dateRandeIsEmpty;
  }

  function isEmptyDateRange(): boolean {
    const invalidMaxDate = !dateCreatedMax && dateCreatedMin != null;
    const invalidMinDate = dateCreatedMax != null && !dateCreatedMin;
    return invalidMaxDate || invalidMinDate;
  }

  function bindQuestionList(onFilter?) {
    if (onFilter && !validateDates()) return;
    setIsResetFlag(false);
    const questionData: IQuestionSearch = {
      questionTypeIds: questionTypeIds,
      stateId: stateId,
      gradeLevel: gradeLevel?.value,
      subjectId: subjectId,
      domainId: domainId,
      standardId: standardId,
      dok: dok,
      tagId: tagId,
      isPublished: isPublished,
      isDiagnostics: isDiagnostics,
      isActive: isActive,
      questionClassificationId: classification,
      orderbyColumn: orderByColumn,
      sortDir: sortAscending ? "ASC" : "DESC",
      pageSize: onFilter ? defaultPageSize : pageSize,
      pageNumber: onFilter ? 1 : pageNumber,
      tagIds: selectedTagIds.toString(),
      tagType: selectedTagCategory?.value
        ? Number(selectedTagCategory?.value)
        : 0,
      translation: translation,
      explanation: explanation,
      showLinkedStandardQuestions: showLinkedItems,
      contentAreaId:
        selectedContentArea.value !== "0"
          ? parseInt(selectedContentArea.value)
          : 0,
      createdByUserId:
        selectedAuthor.value !== "0" ? parseInt(selectedAuthor.value) : 0,
      dateCreatedMax: dateCreatedMax,
      dateCreatedMin: dateCreatedMin,
    };

    if (filterQuestionId) {
      questionData.questionId = filterQuestionId;
    }

    if (filterQuestionText) {
      questionData.questionText = filterQuestionText;
    }

    if (filterJsonDefinition) {
      questionData.jsonDefinition = filterJsonDefinition;
    }

    if (filterSourceId) {
      questionData.externalSourceId = filterSourceId;
    }

    if (externalSourceTypeId) {
      questionData.externalSourceTypeId = externalSourceTypeId;
    }

    if (feedbackSearchText) {
      questionData.feedbackSearch = feedbackSearchText;
    }

    setQuestionList([]);
    bindQuestionListWithPageCheck(questionData, onFilter);
  }

  function handleDomainChange(selectedItem: any) {
    setDomainId(selectedItem);
  }

  function handleStandardChange(selectedItem: any) {
    setStandardId(selectedItem);
  }

  function handleQuestionTypeChange(e: any) {
    setQuestionTypeIds(e?.map((selected) => selected.value) ?? []);
  }

  function handleStateChange(selectedItem: any) {
    setStateId(selectedItem);
  }

  function handleGradeLevelChange(selectedItem: any) {
    setGradeLevel(selectedItem);
  }

  function handleSubjectChange(selectedItem: any) {
    setSubjectId(selectedItem);
  }
  function handleDOKChange(selectedItem: any) {
    setDok(selectedItem);
  }

  const editHandler = (questionId) => {
    navigate(constant.MANAGEQUESTION.replace(":id", questionId.toString()), {
      state: { questionIdToEdit: questionId },
    });
  };

  function confirmDelete(idToDelete?: number) {
    if (idToDelete) {
      setShowDeletePopup(true);
      setQuestionDelete(idToDelete);
    }
  }

  function deleteRecord() {
    const userId = 1;
    deleteQuestion(questionDelete, userId).then(() => {
      setShowDeletePopup(false);
      setQuestionDelete(0);
      bindQuestionList();
    });
  }

  function closeDeletePopup() {
    setShowDeletePopup(false);
    setQuestionDelete(0);
  }

  const openModal = (id, questionId, question) => {
    setOpen(true);
    setPreviewId(id);
    setQuestionToPreview(question);
    setQuestionIdPreview(questionId);
  };

  const popUpClose = (value) => {
    setOpen(value);
    setPreviewId("");
    setQuestionIdPreview(undefined);
    setQuestionToPreview(undefined);
  };

  useEffect(() => {
    if (isLoaded && !isFilter) {
      bindQuestionList();
    }
  }, [pageNumber]);

  useEffect(() => {
    if (isLoaded && !isFilter && !isReset) {
      bindQuestionList(true);
    }
  }, [selectedTagIds]);

  useEffect(() => {
    if (pageNumber === 1 && !isFilter) {
      if (isLoaded) {
        bindQuestionList();
      }
      setIsLoaded(true);
    } else {
      paginationRef?.current?.onReset();
    }
  }, [pageSize]);

  useEffect(() => {
    bindCategories();
    bindStateData();
    subjectByStateId();
    bindClassification();
    getContent();
    bindAuthor();
  }, []);

  useEffect(() => {
    if (subjectId) {
      domainBySubjectId();
    }

    if (domainId) {
      standardByDomainId();
    }
  }, [subjectId, domainId]);

  const subjectByStateId = async () => {
    const service = await import("../../../api/subject.service");
    const response = service.getSubjectByState(
      99999,
      pageNumber,
      stateId,
      true,
      true,
      gradeLevel?.value
    );
    const data = (await response).data;
    const options = data.data.map((item) => {
      return {
        label: item.name,
        value: item.subjectId,
      };
    });
    setSubjects(options);
  };

  const bindStateData = async () => {
    const service = await import("../../../api/subject.service");
    const response = service.getStateAll(999, pageNumber);
    const data = (await response).data;
    const options = data.data.map((item) => {
      return {
        label: item.name,
        value: item.stateId,
      };
    });
    setState(options);
  };

  async function standardByDomainId() {
    setLoading(true);
    const standard: IStandard = {
      name: "",
      contentAreaId: "",
      subjectId: "",
      domainId: domainId + "",
      code: "",
      isActive: true,
      isApproved: true,
      description: "",
      loadOrder: 0,
      pageSize: 99999,
      pageNumber: pageNumber,
      orderbyColumn: "Name",
      sortDir: "ASC",
    };
    const service = await import("../../../api/standard.service");
    service.getStandards(standard).then((response: any) => {
      setLoading(false);

      const options = response.data.data.map((item) => {
        return {
          label: `[${item.code}] ${item.name}`,
          value: item.standardId,
        };
      });
      setStandard(options);
    });
  }

  const domainBySubjectId = async () => {
    const service = await import("../../../api/domain.service");
    service.getAllDomainsBySubject(subjectId, 99999, pageNumber).then((res) => {
      const options = res.data.data.map((item) => {
        return {
          label: item.name,
          value: item.domainId,
        };
      });
      setDomain(options);
    });
  };

  const handleRedirect = () => {
    navigate(constant.AUTHORQUESTION, { state: { questionIdToEdit: null } });
  };

  const bindClassification = () => {
    const dropOption: any = [];
    dropOption.push(defaultClassification);
    getClassifications().then((response: any) => {
      response.data.map((values: any) => {
        dropOption.push({
          label: values?.name,
          value: values?.questionClassificationId,
        });
      });
      setQuestionClassification(dropOption);
    });
  };

  function handleFilterQuestionIdChange(e: any) {
    setFilterQuestionId(e.target.value);
  }

  function handleFilterQuestionTextChange(e: any) {
    setFilterQuestionText(e.target.value);
  }

  function handleFilterJsonDefinitionChange(e: any) {
    setFilterJsonDefinition(e.target.value);
  }

  function handleFeedbackSearchTextChange(e: any) {
    setFeedbackSearchText(e.target.value);
  }

  function handleFilterSourceIdChange(e: any) {
    setFilterSourceId(e.target.value);
  }

  const exportFn = async () => {
    setLoading(true);
    const questionData: IQuestionSearch = {
      questionTypeIds: questionTypeIds,
      stateId: stateId,
      gradeLevel: gradeLevel?.value,
      subjectId: subjectId,
      domainId: domainId,
      standardId: standardId,
      dok: dok,
      tagId: tagId,
      isPublished: isPublished,
      isDiagnostics: isDiagnostics,
      isActive: isActive,
      questionClassificationId: classification,
      orderbyColumn: orderByColumn,
      sortDir: sortAscending ? "ASC" : "DESC",
      pageSize: 1048575,
      pageNumber: 1,
      tagIds: selectedTagIds.toString(),
      tagType: selectedTagCategory?.value
        ? Number(selectedTagCategory?.value)
        : 0,
      translation: translation,
      explanation: explanation,
      showLinkedStandardQuestions: showLinkedItems,
      contentAreaId:
        selectedContentArea.value !== "0"
          ? parseInt(selectedContentArea.value)
          : 0,
      createdByUserId:
        selectedAuthor.value !== "0" ? parseInt(selectedAuthor.value) : 0,
      dateCreatedMax: dateCreatedMax,
      dateCreatedMin: dateCreatedMin,
    };

    if (filterQuestionId) {
      questionData.questionId = filterQuestionId;
    }

    if (filterQuestionText) {
      questionData.questionText = filterQuestionText;
    }

    if (filterJsonDefinition) {
      questionData.jsonDefinition = filterJsonDefinition;
    }

    if (filterSourceId) {
      questionData.externalSourceId = filterSourceId;
    }

    if (externalSourceTypeId) {
      questionData.externalSourceTypeId = externalSourceTypeId;
    }

    if (feedbackSearchText) {
      questionData.feedbackSearch = feedbackSearchText;
    }

    const response = getQuestionExport(questionData);
    const data = await response;
    setLoading(false);

    if (data && data.data && data.data.length > 0) {
      childRef?.current?.onDownload(data.data, "questions.csv");
    } else {
      toast.warning("No records to download");
    }
  };

  const handleCreatedDateStart = (date: Date | null) => {
    if (date) {
      setDateCreatedMin(getStartDate(date));
      if (isInvalidDateRange && dateCreatedMax) setIsInvalidDateRange(false);
    } else {
      setDateCreatedMin(undefined);
    }
  };

  const handleCreatedDateEnd = (date: Date | null) => {
    if (date) {
      setDateCreatedMax(getEndDate(date));
      if (isInvalidDateRange && dateCreatedMin) setIsInvalidDateRange(false);
    } else {
      setDateCreatedMax(undefined);
    }
  };

  const handleFilterTags = (tags) => {
    const selectedTagIds = tags
      .filter((tag) => tag.selected === true)
      .map((tag) => tag.tagId);
    setSelectedTagIds(selectedTagIds);
  };

  const handleTagClick = (tag) => {
    setSelectedTagIds([tag.tagId]);
  };

  const handleUntagged = () => {
    setSelectedTagIds([0]);
  };
  const getContent = async () => {
    const module = await import("../../../api/contentArea.service");
    const response = module.getContentArea(999, 1);
    const data = (await response).data;
    let contentDropdownData: any = [];
    if (data.data.length > 0) {
      contentDropdownData = data.data.map((eachContentData) => {
        return {
          value: eachContentData.contentAreaId || 0,
          label: `${eachContentData.name}`,
        };
      });
    }
    setContentArea(contentDropdownData);
  };

  const handleContentAreaChange = (e: any) => {
    if (e === null) {
      setSelectedContentArea(defaultValue);
    } else {
      setSelectedContentArea(e);
    }
  };
  const handleAuthorChange = (e: any) => {
    if (e === null) {
      setSelectedAuthor(defaultObject);
    } else {
      setSelectedAuthor(e);
    }
  };
  function bindAuthor() {
    getAuthours().then((response) => {
      let newAuthors = [];
      if (response.data.length > 0) {
        newAuthors = response.data.map((element) => {
          return {
            value: element.authorId,
            label: `${element.lastName}, ${element.firstName}`,
          };
        });
      }
      setAuthors(newAuthors);
    });
  }

  return (
    <AllowedTo perform={Permissions.question_view} no={() => <AccessDenied />}>
      {loading && <Loader />}

      {showDeletePopup && (
        <DeleteModal
          closeDeleteModal={closeDeletePopup}
          deleteRecord={deleteRecord}
        />
      )}
      <PreviewModal
        modal={openModal}
        show={open}
        changeValue={popUpClose}
        itemRef={previewId}
        questionIdPreview={questionIdPreview}
        questionIndexPreview={questionIndexPreview}
        setQuestionIndexPreview={setQuestionIndexPreview}
        questions={questionList}
        setQuestionIdPreview={setQuestionIdPreview}
        setPreviewId={setPreviewId}
        questionToPreview={questionToPreview}
        setQuestionToPreview={setQuestionToPreview}
      ></PreviewModal>
      <div className="flex-1 overflow-auto">
        <div className=" h-auto min-h-half w-full rounded-bl-3xl bg-site-teal px-8  py-8 pt-0 pb-14 mt-7 ">
          <div className="relative  py-1">
            <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>
            <div className="flex items-center justify-between pb-4">
              <h3 className="text-lg font-light text-gray-900">Question</h3>

              <AllowedTo perform={Permissions.question_create}>
                <button
                  type="button"
                  className="inline-flex items-center px-3 py-1 border border-transparent text-sm leading-4 rounded-md shadow-xs text-white dark:text-white bg-primary-color hover:bg-secondary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color hover:shadow-lg transition ease-in-out duration-300"
                  onClick={() => handleRedirect()}
                >
                  <AddIcon className="w-5"></AddIcon>
                  Add Question
                </button>
              </AllowedTo>
            </div>
            <div className={"pt-6"}>
              <div className={"grid grid-cols-12 gap-5 border-b pb-6"}>
                <div className={"col-span-3"}>
                  <div className="text-sm text-gray-700">Question Id</div>
                  <input
                    id="questionId"
                    name="questionId"
                    type="number"
                    autoComplete="off"
                    className="w-full mt-1 order border-gray-300 rounded-md shadow-sm py-2 px-4 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-black sm:text-sm"
                    value={filterQuestionId || ""}
                    onChange={handleFilterQuestionIdChange}
                    onWheel={(e) => e.currentTarget.blur()}
                  />
                </div>
                <div className="col-span-3">
                  <div className="text-sm text-gray-700">
                    Created Date Start
                  </div>
                  <DatePicker
                    wrapperClassName="mt-0.5"
                    className={`react-datepicker__input-container py-2 px-3 block shadow-sm focus:ring-primary-violet focus:border-primary-violet border border-${
                      isInvalidDateRange ? "red-400" : "gray-300"
                    } rounded-md text-gray-700 text-sm dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-black`}
                    selected={dateCreatedMin}
                    onChange={(date) => {
                      handleCreatedDateStart(date);
                    }}
                    maxDate={dateCreatedMax ? dateCreatedMax : new Date()}
                  />
                </div>
                <div className="col-span-3">
                  <div>Created Date End</div>
                  <DatePicker
                    wrapperClassName="mt-0.5"
                    className={`react-datepicker__input-container py-2 px-3 block shadow-sm focus:ring-primary-violet focus:border-primary-violet border border-${
                      isInvalidDateRange ? "red-400" : "gray-300"
                    } rounded-md text-gray-700 text-sm dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-black`}
                    selected={dateCreatedMax}
                    onChange={(date) => {
                      handleCreatedDateEnd(date);
                    }}
                    maxDate={new Date()}
                    minDate={dateCreatedMin}
                  />
                </div>
                <div className="grid grid-cols-2 col-span-3">
                  <div className="col-span-1">
                    <div className="text-sm text-gray-700">Question Text</div>
                    <input
                      id="questionText"
                      name="questionText"
                      type="text"
                      autoComplete="off"
                      className="w-full mt-1 order border-gray-300 rounded-md shadow-sm py-2 px-4 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                      value={filterQuestionText || ""}
                      onChange={handleFilterQuestionTextChange}
                    />
                  </div>
                  <div className="col-span-1">
                    <div className="text-sm text-gray-700">JSON</div>
                    <input
                      id="jsonDefinition"
                      name="jsonDefinition"
                      type="text"
                      autoComplete="off"
                      className="w-full mt-1 order border-gray-300 rounded-md shadow-sm py-2 px-4 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                      value={filterJsonDefinition || ""}
                      onChange={handleFilterJsonDefinitionChange}
                    />
                  </div>
                </div>
                <div className={"col-span-3"}>
                  <div className="text-sm text-gray-700 mb-1">
                    Ext. Source ID
                  </div>
                  <div className="flex justify-between space-x-6">
                    <div className="w-full">
                      <Select
                        placeholder={""}
                        options={EXTERNAL_SOURCE_TYPES}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary25: "#B3B3B3",
                            primary: "#041E42",
                          },
                        })}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            background:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#1A1C23"
                                : "white",
                            borderColor:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#6B7280"
                                : "#D1D5DB",
                            borderWidth: "1px",
                            "&:hover": {
                              borderColor:
                                state.isFocused &&
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#6b7280"
                                  : state.isFocused
                                  ? "#4c5563"
                                  : "",
                            },
                          }),
                          singleValue: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "#374051",
                          }),
                          input: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "",
                          }),
                        }}
                        isSearchable={false}
                        isClearable={true}
                        value={EXTERNAL_SOURCE_TYPES.filter(
                          (t) => t.value == externalSourceTypeId
                        )}
                        onChange={handleExternalSourceTypeIdChange}
                      />
                    </div>
                    <input
                      id="sourceId"
                      name="sourceId"
                      type="text"
                      autoComplete="off"
                      placeholder="ID"
                      className="w-full order border-gray-300 rounded-md shadow-sm py-2 px-4 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                      value={filterSourceId || ""}
                      onChange={handleFilterSourceIdChange}
                      onWheel={(e) => e.currentTarget.blur()}
                    />
                  </div>
                </div>

                <div className="col-span-3">
                  <div className="text-sm text-gray-700">Question Type</div>
                  <div className="mt-1 text-sm">
                    <QuestionTypeSelect
                      onChange={handleQuestionTypeChange}
                      value={questionTypeIds}
                      multiple={true}
                    ></QuestionTypeSelect>
                  </div>
                </div>

                <div className={"col-span-3"}>
                  <div className="text-sm text-gray-700"> State</div>
                  <div className="mt-1 text-sm">
                    <DropDownComponent
                      dropName={"stateList"}
                      dropValue={state}
                      resetDropdown={resetDropdownFlag}
                      defaultValue={""}
                      dropSelect={handleStateChange}
                      enableDisableSubjects={setEnableDisableSubjects}
                    ></DropDownComponent>
                  </div>
                </div>

                <div className={"col-span-3"}>
                  <div className="text-sm text-gray-700"> Grade Level</div>
                  <div className="mt-1 text-sm">
                    <Select
                      className="mt-1 text-sm"
                      value={gradeLevel}
                      onChange={handleGradeLevelChange}
                      options={gradeLevelData}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "#B3B3B3",
                          primary: "#041E42",
                        },
                      })}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          background:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#1A1C23"
                              : "white",
                          borderColor:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#6B7280"
                              : "#D1D5DB",
                          borderWidth: "1px",
                          "&:hover": {
                            borderColor:
                              state.isFocused &&
                              document.getElementsByClassName("dark")?.length >
                                0
                                ? "#6b7280"
                                : state.isFocused
                                ? "#4c5563"
                                : "",
                          },
                        }),
                        singleValue: (base) => ({
                          ...base,
                          color:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "white"
                              : "#374051",
                        }),
                        input: (base) => ({
                          ...base,
                          color:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "white"
                              : "",
                        }),
                      }}
                    />
                  </div>
                </div>

                <div className={"col-span-3"}>
                  <div className={"text-sm text-gray-700"}>Subject</div>
                  <div className="mt-1 text-sm">
                    <DropDownComponent
                      dropName={"subjectList"}
                      dropValue={subjects}
                      resetDropdown={resetDropdownFlag}
                      defaultValue={""}
                      dropSelect={handleSubjectChange}
                      enableDisableDomains={setEnableDisableDomains}
                    ></DropDownComponent>
                  </div>
                </div>

                <div className={"col-span-3"}>
                  <div className="text-sm text-gray-700">Domain</div>
                  <div className="mt-1 text-sm">
                    <DropDownComponent
                      dropName={"domainList"}
                      dropValue={domain}
                      defaultValue={""}
                      resetDropdown={resetDropdownFlag}
                      dropSelect={handleDomainChange}
                      enableDisableStandards={setEnableDisableStandards}
                    ></DropDownComponent>
                  </div>
                </div>

                <div className={"col-span-3"}>
                  <div className="text-sm text-gray-700">Standard</div>
                  <div className="mt-1 text-sm">
                    <DropDownComponent
                      dropName={"standardList"}
                      dropValue={standard}
                      defaultValue={""}
                      resetDropdown={resetDropdownFlag}
                      dropSelect={handleStandardChange}
                      questionId={questionId}
                      setQuestionId={setQuestionId}
                    ></DropDownComponent>
                  </div>
                </div>

                <div className={"col-span-3"}>
                  <div className="text-sm text-gray-700">DOK</div>
                  <div className="mt-1 text-sm">
                    <DropDownComponent
                      dropName={"dokList"}
                      dropValue={constant.DOK}
                      resetDropdown={resetDropdownFlag}
                      defaultValue={""}
                      dropSelect={handleDOKChange}
                    />
                  </div>
                </div>
                <div className={"col-span-3"}>
                  <div className="text-sm text-gray-700 mb-1">
                    Classification
                  </div>
                  <div className="flex justify-between space-x-6">
                    <div className="w-full">
                      <Select
                        placeholder={""}
                        options={questionClassification}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary25: "#B3B3B3",
                            primary: "#041E42",
                          },
                        })}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            background:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#1A1C23"
                                : "white",
                            borderColor:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#6B7280"
                                : "#D1D5DB",
                            borderWidth: "1px",
                            "&:hover": {
                              borderColor:
                                state.isFocused &&
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#6b7280"
                                  : state.isFocused
                                  ? "#4c5563"
                                  : "",
                            },
                          }),
                          singleValue: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "#374051",
                          }),
                          input: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "",
                          }),
                        }}
                        isSearchable={false}
                        isClearable={true}
                        value={selectedClassification}
                        onChange={handleQuestionClassificationChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-span-1 flex items-center mt-6">
                  <div className={"flex items-end"}>
                    <label className="flex items-center">
                      <input
                        id="active"
                        name="isDiagnostic"
                        type="checkbox"
                        checked={isDiagnostics}
                        onChange={() => setIsDiagnostics(!isDiagnostics)}
                        className=" focus:ring-primary-color h-4 w-4 text-primary-color border-gray-300 rounded"
                      />
                      <span className="ml-2 dark:text-white">Diagnostic</span>
                    </label>
                  </div>
                </div>
                <div className="col-span-2 flex items-center mt-6">
                  <div className={"flex items-end"}>
                    <label className="flex items-center">
                      <input
                        id="active"
                        name="showLinkedItems"
                        type="checkbox"
                        checked={showLinkedItems}
                        onChange={() => setShowLinkedItems(!showLinkedItems)}
                        className=" focus:ring-primary-color h-4 w-4 text-primary-color border-gray-300 rounded"
                      />
                      <span className="ml-2 dark:text-white">
                        Linked Standard Questions
                      </span>
                    </label>
                  </div>
                </div>
                <div className={"col-span-3"}>
                  <div className="text-sm text-gray-700 mb-1">Published</div>
                  <div className="flex justify-between space-x-6">
                    <div className="w-full">
                      <MultiStateButton
                        labels={publishedMultiState}
                        onSelect={(e) => setIsPublished(e.value)}
                        onReset={resetDropdownFlag}
                      />
                    </div>
                  </div>
                </div>
                <div className={"col-span-3"}>
                  <div className="text-sm text-gray-700 mb-1">Translation</div>
                  <div className="flex justify-between space-x-6">
                    <div className="w-full">
                      <MultiStateButton
                        labels={translationMultiState}
                        onSelect={(e) => {
                          setTranslation(e.value);
                        }}
                        onReset={resetDropdownFlag}
                      />
                    </div>
                  </div>
                </div>
                <div className={"col-span-3"}>
                  <div className="text-sm text-gray-700 mb-1">Content Area</div>
                  <div className="flex justify-between space-x-6">
                    <div className="w-full">
                      <Select
                        placeholder={""}
                        options={contentArea}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary25: "#B3B3B3",
                            primary: "#041E42",
                          },
                        })}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            background:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#1A1C23"
                                : "white",
                            borderColor:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#6B7280"
                                : "#D1D5DB",
                            borderWidth: "1px",
                            "&:hover": {
                              borderColor:
                                state.isFocused &&
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#6b7280"
                                  : state.isFocused
                                  ? "#4c5563"
                                  : "",
                            },
                          }),
                          singleValue: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "#374051",
                          }),
                          input: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "",
                          }),
                        }}
                        isSearchable={false}
                        isClearable={true}
                        value={selectedContentArea}
                        onChange={handleContentAreaChange}
                      />
                    </div>
                  </div>
                </div>
                <div className={"col-span-3"}>
                  <div className="text-sm text-gray-700 mb-1">Author</div>
                  <div className="flex justify-between space-x-6">
                    <div className="w-full">
                      <Select
                        placeholder={""}
                        options={authors}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary25: "#B3B3B3",
                            primary: "#041E42",
                          },
                        })}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            background:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#1A1C23"
                                : "white",
                            borderColor:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#6B7280"
                                : "#D1D5DB",
                            borderWidth: "1px",
                            "&:hover": {
                              borderColor:
                                state.isFocused &&
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#6b7280"
                                  : state.isFocused
                                  ? "#4c5563"
                                  : "",
                            },
                          }),
                          singleValue: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "#374051",
                          }),
                          input: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "",
                          }),
                        }}
                        isSearchable={false}
                        isClearable={true}
                        value={selectedAuthor}
                        onChange={handleAuthorChange}
                      />
                    </div>
                  </div>
                </div>
                <div className={"col-span-3"}>
                  <div className="text-sm text-gray-700 mb-1">Active</div>
                  <div className="flex justify-between space-x-6">
                    <div className="w-full">
                      <MultiStateButton
                        labels={activeMultiState}
                        onSelect={(e) => setIsActive(e.value)}
                        onReset={resetDropdownFlag}
                      />
                    </div>
                  </div>
                </div>
                <div className={"col-span-3"}>
                  <div className="text-sm text-gray-700 mb-1">Explanation</div>
                  <div className="flex justify-between space-x-6">
                    <div className="w-full">
                      <MultiStateButton
                        labels={explanationMultiState}
                        onSelect={(e) => {
                          setExplanation(e.value);
                        }}
                        onReset={resetDropdownFlag}
                      />
                    </div>
                  </div>
                </div>
                <div className={"col-span-3"}>
                  <div className="text-sm text-gray-700 mb-1">Tag Type</div>
                  <div className="flex justify-between space-x-6">
                    <div className="w-full">
                      <Select
                        placeholder={""}
                        options={categories}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary25: "#B3B3B3",
                            primary: "#041E42",
                          },
                        })}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            background:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#1A1C23"
                                : "white",
                            borderColor:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#6B7280"
                                : "#D1D5DB",
                            borderWidth: "1px",
                            "&:hover": {
                              borderColor:
                                state.isFocused &&
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#6b7280"
                                  : state.isFocused
                                  ? "#4c5563"
                                  : "",
                            },
                          }),
                          singleValue: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "#374051",
                          }),
                          input: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "",
                          }),
                        }}
                        isSearchable={false}
                        isClearable={true}
                        value={selectedTagCategory}
                        onChange={(e) => handleTagCategoryChange(e)}
                      />
                    </div>
                    <div className="flex items-end">
                      <div className="flex items-center contentArea">
                        <TagSelector
                          label={"Tags"}
                          onTagSelectChange={(tags) => {
                            handleFilterTags(tags);
                          }}
                          onFilterUntagged={() => {
                            handleUntagged();
                          }}
                          removeTag={(tags, tag) => {
                            handleFilterTags(tags);
                          }}
                          mode={TagSelectorMode.Filter}
                          categoryId={selectedTagCategory?.value}
                          selectedTagIds={selectedTagIds}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className={"col-span-3"}>
                  <div className="text-sm text-gray-700">Feedback Search</div>
                  <input
                    id="feedbackSearch"
                    name="feedbackSearch"
                    type="text"
                    autoComplete="off"
                    className="w-full mt-1 order border-gray-300 rounded-md shadow-sm py-2 px-4 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                    value={feedbackSearchText || ""}
                    onChange={handleFeedbackSearchTextChange}
                  />
                </div>

                <div className="col-span-12">
                  <button
                    type="submit"
                    className="mt-4 inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
                    onClick={() => bindQuestionList(true)}
                  >
                    <FilterIcon className="w-3 h-3"></FilterIcon>
                    <span>Filter</span>
                  </button>
                  <button
                    type="button"
                    className="mt-4 py-1.5 px-4 inline-flex ml-3 items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
                    onClick={() => resetFilterHandler()}
                  >
                    <ResetIcon className="w-3 h-3"></ResetIcon>
                    <span>Reset Filter</span>
                  </button>
                </div>
              </div>

              <div className={"grid grid-cols-12 gap-5"}></div>
              <div className="flex mt-4 items-center justify-end">
                <div className="flex space-x-4 items-center dark:text-white">
                  <div className="flex items-center">
                    <span className="w-1 h-4 bg-green-500 rounded-md inline-block mr-2"></span>
                    Active
                  </div>
                  <div className="flex items-center ">
                    <VideoLegendIcon />
                    <div className="pl-2">Video</div>
                  </div>

                  <div className="flex items-center ">
                    <TextIcon />
                    <div className="pl-2">Text</div>
                  </div>
                  <div className="flex items-center ">
                    <SpanishTransIcon className="text-gray-400 fill-current h-4 w-4" />
                    <div className="pl-2">Translation</div>
                  </div>

                  <div className="flex items-center">
                    <ApproveIcon />
                    <div className="pl-2">Published</div>
                  </div>
                  <button
                    type="button"
                    onClick={() => exportFn()}
                    className="py-1.5 px-4 inline-flex ml-auto items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
                  >
                    <CSVIcon className="w-3 h-3 dark:text-white stroke-current"></CSVIcon>
                    <span>Export</span>
                  </button>
                  <ExportToCSV ref={childRef} />
                  <div className="flex items-center ">
                    <PreviewIcon className="mr-0 h-5 w-5 text-xs font-light cursor-pointer text-gray-400 hover:text-secondary-color transaction ease-in-out duration-300" />
                    <div className="pl-2">Preview</div>
                  </div>
                  <div className="flex items-center ">
                    <DeleteIcon className="mr-0 h-5 w-5 text-xs font-light cursor-pointer hover:text-red-500 transaction ease-in-out duration-300" />
                    <div className="pl-2">Delete</div>
                  </div>
                </div>
              </div>
            </div>
            <div id="dataContainer" className="mt-4">
              <div className="flex flex-col mt-1">
                <div className="-my-2 relative sm:-mx-6 lg:-mx-8">
                  <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div className="shadow border-b border-gray-200 ">
                      <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-primary-color">
                          <tr>
                            <th
                              scope="col"
                              className="px-5 py-2 pl-6 font-light text-sm text-left text-white dark:text-white tracking-wider w-32 rounded-tl-lg"
                            >
                              <span className="flex gap-2">
                                Id
                                <span className="cursor-pointer">
                                  {!sortAscending &&
                                  orderByColumn === "QuestionId" ? (
                                    <CaretUpSolidIcon
                                      onClick={() => handleSort("QuestionId")}
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() => handleSort("QuestionId")}
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-wrap text-sm text-left text-white dark:text-white "
                            >
                              <span className="flex gap-2">
                                Question
                                <span className="cursor-pointer">
                                  {!sortAscending &&
                                  orderByColumn === "questionText" ? (
                                    <CaretUpSolidIcon
                                      onClick={() => handleSort("questionText")}
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() => handleSort("questionText")}
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 pl-6 font-light text-sm text-left text-white dark:text-white tracking-wider"
                            >
                              <span className="flex gap-2">
                                Type
                                <span className="cursor-pointer">
                                  {!sortAscending &&
                                  orderByColumn === "questionTypeName" ? (
                                    <CaretUpSolidIcon
                                      onClick={() =>
                                        handleSort("questionTypeName")
                                      }
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() =>
                                        handleSort("questionTypeName")
                                      }
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>

                            <th
                              scope="col"
                              className="px-3 py-2 pl-6 font-light text-sm text-left text-white dark:text-white tracking-wider"
                            >
                              <span className="flex gap-2">
                                Subject
                                <span className="cursor-pointer">
                                  {!sortAscending &&
                                  orderByColumn === "Subject" ? (
                                    <CaretUpSolidIcon
                                      onClick={() => handleSort("Subject")}
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() => handleSort("Subject")}
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-wrap text-sm text-left text-white dark:text-white "
                            >
                              <span className="flex gap-2">
                                Domain
                                <span className="cursor-pointer">
                                  {!sortAscending &&
                                  orderByColumn === "Domain" ? (
                                    <CaretUpSolidIcon
                                      onClick={() => handleSort("Domain")}
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() => handleSort("Domain")}
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-wrap text-sm text-left text-white dark:text-white "
                            >
                              <span className="flex gap-2">
                                Standard
                                <span className="cursor-pointer">
                                  {!sortAscending &&
                                  orderByColumn === "Standard" ? (
                                    <CaretUpSolidIcon
                                      onClick={() => handleSort("Standard")}
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() => handleSort("Standard")}
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-wrap text-sm text-left text-white dark:text-white"
                            >
                              <span className="flex gap-2">Classification</span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-wrap text-sm text-left text-white dark:text-white"
                            >
                              <span className="flex gap-2">DOK</span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-wrap text-sm text-left text-white dark:text-white"
                            >
                              <span className="flex gap-2">Exp</span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-wrap text-sm text-center text-white dark:text-white"
                            >
                              <SpanishTransIcon className="dark:text-white fill-current h-4 w-4" />
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light text-sm text-center text-white dark:text-white tracking-wider rounded-tr-lg"
                            ></th>
                          </tr>
                        </thead>
                        <tbody>
                          {questionList.map((question, index) => {
                            question.questionText =
                              question.questionText?.replaceAll(/\\'s/g, "'s");
                            return (
                              <>
                                <tr
                                  key={index}
                                  className={
                                    index % 2 === 0 ? "bg-white" : "bg-gray-100"
                                  }
                                >
                                  <td className="px-3 py-2 pl-6  text-sm text-left font-normal text-gray-500 relative">
                                    <div className="flex">
                                      {question.isActive ? (
                                        <span className="mr-1 mt-2 h-full w-0.5 bg-green-500 rounded-md inline-block absolute top-0 left-1.5"></span>
                                      ) : (
                                        <span className="mr-1 mt-2 h-full w-0.5 bg-red-500 rounded-md inline-block absolute top-0 left-1.5"></span>
                                      )}

                                      <div className="flex">
                                        <CopyIcon
                                          className="h-5 cursor-pointer"
                                          title="Copy id"
                                          onClick={() =>
                                            Copy([question.questionId])
                                          }
                                        />
                                        <Link
                                          className="pl-1 cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                          to={constant.MANAGEQUESTION.replace(
                                            ":id",
                                            question.questionId!.toString()
                                          )}
                                        >
                                          {question.questionId}
                                        </Link>
                                        <UgaItemIcon
                                          externalSourceTypeId={
                                            question.externalSourceTypeId
                                          }
                                          className="ml-1.5 self-center"
                                        />
                                      </div>
                                    </div>
                                  </td>
                                  <td className="px-3 py-2  pl-6 whitespace-wrap text-sm text-left font-normal text-gray-500">
                                    <Link
                                      className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                      to={constant.MANAGEQUESTION.replace(
                                        ":id",
                                        question.questionId!.toString()
                                      )}
                                    >
                                      <Tooltip
                                        text={question?.questionText}
                                        length={25}
                                      />
                                    </Link>
                                  </td>
                                  <td className="px-3 py-2  pl-6 whitespace-wrap text-sm text-left font-normal text-gray-500">
                                    {question.questionTypeName}
                                  </td>
                                  <td className="px-3 py-2  pl-6 whitespace-wrap text-sm text-left font-normal text-gray-500">
                                    <Link
                                      className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                      to={constant.SUBJECTDETAIL.replace(
                                        ":id",
                                        question.subjectId!.toString()
                                      )}
                                    >
                                      {question.subjectName}
                                    </Link>
                                  </td>
                                  <td className="px-3 py-2 whitespace-wrap text-sm text-left font-normal text-gray-500">
                                    <Link
                                      className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                      to={constant.EDITDOMAIN.replace(
                                        ":id",
                                        question.domainId!.toString()
                                      )}
                                    >
                                      {question.domainName}
                                    </Link>
                                  </td>
                                  <td className="px-3 py-2 whitespace-wrap text-sm text-left font-normal text-gray-500">
                                    <Link
                                      className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                      to={constant.EDITSTANDARD.replace(
                                        ":id",
                                        question.standardId!.toString()
                                      )}
                                    >
                                      [{question.standardCode}]{" "}
                                      {question.standardName}
                                    </Link>
                                  </td>
                                  <td className="px-3 py-2 whitespace-wrap text-sm text-left font-normal text-gray-500">
                                    {question.questionClassification}
                                  </td>
                                  <td className="px-3 py-2 whitespace-wrap text-sm text-left font-normal text-gray-500">
                                    {question.dok}
                                  </td>
                                  <td className="px-3 py-2 whitespace-wrap text-sm text-center font-normal">
                                    <div className="flex items-center">
                                      {question.settings?.filter((e) => {
                                        return e.videoExplanation != undefined;
                                      })[0]?.videoExplanation && (
                                        <span className="relative w-11 inline-block">
                                          <VideoLegendIcon title="Video explanation available for this subject" />
                                        </span>
                                      )}
                                    </div>
                                  </td>
                                  <td className="px-3 py-2 whitespace-wrap text-sm text-left font-normal">
                                    {question.isHumanTranslated ? (
                                      <HumanIcon
                                        title="Human Translated"
                                        className="w-4 h-4"
                                      />
                                    ) : question.isMachineTranslated ? (
                                      <MachineIcon
                                        title="Machine Translated"
                                        className="w-4 h-4"
                                      />
                                    ) : (
                                      "-"
                                    )}
                                  </td>
                                  <td className="flex justify-end items-center px-3 py-2 whitespace-wrap text-sm text-center font-normal text-gray-700">
                                    <div className="flex space-x-2 justify-center items-center">
                                      {question.isDiagnostics && (
                                        <DiagnosticIcon />
                                      )}
                                      {question.isPublished ? (
                                        <ApproveIcon title="Approved" />
                                      ) : (
                                        <Disapprove />
                                      )}

                                      <a
                                        onClick={() =>
                                          openModal(
                                            question.englishQuestionReferenceId,
                                            question.questionId,
                                            question
                                          )
                                        }
                                        className="text-gray-900"
                                      >
                                        <PreviewIcon className="mr-3 h-5 w-5 text-xs font-light cursor-pointer text-gray-400 hover:text-secondary-color transaction ease-in-out duration-300" />
                                      </a>

                                      <AllowedTo
                                        perform={Permissions.question_delete}
                                      >
                                        <a
                                          onClick={() =>
                                            confirmDelete(question.questionId)
                                          }
                                          className="text-gray-900"
                                        >
                                          <DeleteIcon className="mr-3 h-5 w-5 text-xs font-light cursor-pointer hover:text-red-500 transaction ease-in-out duration-300" />
                                        </a>
                                      </AllowedTo>
                                    </div>
                                  </td>
                                </tr>
                                <tr
                                  className={
                                    index % 2 === 0 ? "bg-white" : "bg-gray-100"
                                  }
                                >
                                  <td className="pl-6 whitespace-wrap text-sm text-left font-normal text-gray-500 relative">
                                    {question.isActive ? (
                                      <span className="mr-1 mb-2 h-full w-0.5 bg-green-500 rounded-md inline-block absolute top-0 left-1.5"></span>
                                    ) : (
                                      <span className="mr-1 mb-2 h-full w-0.5 bg-red-500 rounded-md inline-block absolute top-0 left-1.5"></span>
                                    )}
                                  </td>
                                  <td colSpan={10}>
                                    {question?.tags?.map((tag) => (
                                      <li
                                        key={tag.tagId}
                                        className={`inline-block bg-[${
                                          tag.color
                                        }] 
                                rounded-full text-xs shadow-sm py-0.5 px-3  whitespace-nowrap mx-1 mb-2 cursor-pointer
                               ${
                                 TagColor.isDark(tag.color)
                                   ? "text-white"
                                   : "text-black"
                               }
                                `}
                                        onClick={() => {
                                          handleTagClick(tag);
                                        }}
                                      >
                                        {tag.name}
                                      </li>
                                    ))}
                                  </td>
                                </tr>
                              </>
                            );
                          })}
                        </tbody>
                      </table>
                      {questionList.length === 0 && (
                        <p className="p-2">No Records Found</p>
                      )}
                    </div>
                  </div>
                </div>

                <div
                  className={`flex justify-between items-center ${
                    questionList.length === 0 ? "hidden" : ""
                  }`}
                >
                  <Pagination
                    pages={totalPages}
                    setPageNumber={setPageNumber}
                    ref={paginationRef}
                  />
                  <span>
                    <span className="text-sm pr-4 ml-auto text-left-700">
                      Showing {pageNumber} to{" "}
                      {totalRecords < pageSize ? totalRecords : pageSize} of{" "}
                      {totalRecords} results
                    </span>

                    <SelectPageSize
                      setPageSize={setPageSize}
                      type={"second"}
                      defaultPage={defaultPageSize}
                      ref={pageSizeRef}
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AllowedTo>
  );
}

export default QuestionList;
